import {
  OrderCargoOrderDetailsComplexSolveNode,
  OrderCargoOrderDetailsComplexSolveStage,
  OrderCargoOrderDetailsComplexTransportingOrder,
} from "../../../../../common/services/order/cargo-order/details-complex/order-cargo-order-details-complex";
import PlanningOrderOrderDetailsRouteItem from "./types/planning-order-order-details-route-item";

const createRouteItemForWaypoint = (
  waypoint: OrderCargoOrderDetailsComplexSolveNode,
  stageNo: number,
): PlanningOrderOrderDetailsRouteItem => {
  return {
    address: waypoint.displayName,
    distance: waypoint.distance,
    estimatedDate: waypoint.estimatedTime,
    orderedDate: waypoint.requestedTime,
    orderedStopoverTime: waypoint.requestedHaltingTime,
    stageNo,
  };
};

const createForNoDriver = (
  waypoints: OrderCargoOrderDetailsComplexSolveStage[],
  stageNo: number,
): PlanningOrderOrderDetailsRouteItem[] => {
  return waypoints
    .map((waypointItem) => {
      if (Array.isArray(waypointItem)) {
        stageNo++;
        return waypointItem.map((waypoint) =>
          createRouteItemForWaypoint(waypoint, stageNo),
        );
      }
      stageNo++;
      return createRouteItemForWaypoint(waypointItem, stageNo);
    })
    .flat();
};

const create = (
  transportingOrders: OrderCargoOrderDetailsComplexTransportingOrder[],
): PlanningOrderOrderDetailsRouteItem[] => {
  const stageNo = 0;

  return transportingOrders
    .map((transportingOrder) => {
      return createForNoDriver(transportingOrder.solve, stageNo);
    })
    .flat();
};

const planningOrderOrderDetailsRouteItemFactory = {
  create,
};

export default planningOrderOrderDetailsRouteItemFactory;
